// Shared by the product page and scripts/inject-metadata.js (CommonJS so Node can require it),
// so visitors and Google read the same product text.
const seo = require('./seoConfig.json');

function cleanText(text) {
    return String(text || '').replace(/[*#_`>]/g, '').replace(/\s+/g, ' ').trim();
}

// Cut at a word boundary so descriptions never end mid-word
function truncate(text, max) {
    if (text.length <= max) return text;
    const cut = text.slice(0, max - 1);
    return cut.slice(0, cut.lastIndexOf(' ')).replace(/[,;:.]$/, '') + '…';
}

function joinSpanish(parts) {
    if (parts.length <= 1) return parts.join('');
    return `${parts.slice(0, -1).join(', ')} y ${parts[parts.length - 1]}`;
}

function frameMaterial(text) {
    if (/carbon/i.test(text || '')) return 'carbono';
    if (/alloy|alumin/i.test(text || '')) return 'aluminio';
    return null;
}

function bikeTypeLabel(categoriaId) {
    return categoriaId ? seo.categoryLabels[String(categoriaId)] || null : null;
}

// 'bicicleta eléctrica de montaña': the type written out, for titles and descriptions
function bikeTypeTitle(categoriaId) {
    return categoriaId ? seo.categoryTitles[String(categoriaId)] || null : null;
}

// Title of a bike page: 'Raymon Airok Comp: bicicleta eléctrica de montaña | PROOMTB & ROAD'
function bikeTitle(modelo, typeTitle) {
    return `Raymon ${modelo}${typeTitle ? `: ${typeTitle}` : ''} | PROOMTB & ROAD`;
}

// Most bikes have no description in the database, so build one from their specs
function describeBike(bike, typeLabel) {
    if (cleanText(bike.description).length > 40) return truncate(cleanText(bike.description), 160);

    const specs = [];
    if (bike.motor_modelo) specs.push(`motor ${bike.motor_modelo.split(',')[0].trim()}${bike.motor_nm ? ` de ${bike.motor_nm} Nm` : ''}`);
    if (bike.bateria_wh) specs.push(`batería de ${bike.bateria_wh} Wh`);
    const frame = frameMaterial(bike.cuadro_material);
    if (frame) specs.push(`cuadro de ${frame}`);
    if (bike.recorrido_mm > 0) specs.push(`${bike.recorrido_mm} mm de recorrido`);
    if (bike.peso_kg) specs.push(`peso de ${bike.peso_kg} kg`);

    const intro = `Raymon ${bike.modelo}${typeLabel ? `, ${typeLabel}` : ''}`;
    const outro = '. Disponible en PROOMTB & ROAD, Santo Domingo.';
    // Drop the least important specs until the text fits in a search snippet
    while (specs.length) {
        const text = `${intro} con ${joinSpanish(specs)}${outro}`;
        if (text.length <= 160) return text;
        specs.pop();
    }
    return `${intro}${outro}`;
}

function describeAccessory(accessory) {
    const name = cleanText(accessory.name);
    return truncate(cleanText(accessory.description) || `${name}. Disponible en PROOMTB & ROAD, Santo Domingo.`, 160);
}

module.exports = { cleanText, truncate, bikeTypeLabel, bikeTypeTitle, bikeTitle, describeBike, describeAccessory };
